export default {
  headerContent: {
    title: 'Generali Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Generali Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası, aracınızın karayolunda veya park halinde karşılaşabileceği risklerin oluşması sonucunca oluşacak yüksek masraflara karşı koruma sağlamaktadır. Araba sigortası, mali korumanız için önemlidir. Hiç kaza yaşamazsanız, asla bir sigorta tazminat talebinde bulunmanız gerekmeyebilir. Ancak istatistiksel olarak hayatınız boyunca en az bir kaza geçirmeniz muhtemeldir ve sonuçları tahmin edemeyeceğiniz büyüklükte olabilir.',
        'Kasko sigortası çarpma, çarpılma ve hırsızlık başta olmak üzere birçok riske karşı güvence sağlamaktadır. Generali Sigorta’nın avantajlı fiyatlarından ve hizmetlerinden yararlanmak için kasko sigortanızı Alokasko.com aracığıyla yaptırabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta Araç Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Kasko sigortası teminatları ana ve ek olmak üzere 2’ye ayrılmıştır. Ana teminatlar tüm poliçelerde ortak olurken ek teminatlar müşterilerin isteğine göre değişmektedir.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Ana teminatlar;</u></em></strong>',
          subList: [
            'Çarpma veya çarpılma,',
            'Yangın,',
            'Çalınma veya çalınmaya teşebbüs sonucu hasarları kapsamaktır.'
          ]
        },
        {
          paragraph: '<strong><em><u>Ek teminatlar;</u></em></strong>',
          subList: [
            'Alevsiz yangın teminatı',
            'Deprem teminatı',
            'Enflasyon teminatı',
            'Eskime payı düşmeme teminatı',
            'Ferdi kaza deprem teminatı',
            'Ferdi kaza teminatı',
            'Hasar ikame teminatı',
            'Hukuksal yardım teminatı',
            'İhtiyari mali mesuliyet teminatı',
            'Kilit sistemi teminatı',
            'Kullanım kaybı teminatı',
            'Sel ve su baskını teminatı',
            'Terör teminatı',
            'Yardım hizmet paketi teminatı',
            'Yurt dışı teminatıdır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Generali Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Generali Sigorta Kasko Sigortası Teminat Dışı Haller Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Araç taşıma kapasitesi üstünde taşıma yapılırken oluşacak hasarlar.',
            'Her türlü savaş olayları sonucu oluşacak hasarlar.',
            'Sigortalı veya birlikte yaşadığı kişilerin kasten vereceği zararlar.',
            'Sürücü belgesi olmayan veya belgesi yetersiz olan kişilerin yapacağı hasarlar.',
            'Uyuşturucu veya alkol etkisinde oluşan hasarlar.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Kasko Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigorta kasko yaş sınırını 15 yaş ile sınırlı tutmuştur. 15 yaş ve altı araç sahipleri Generali Sigorta’dan poliçe tanzim edebilirler.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Kasko Cam Değişimi Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortanızda bulunan cam teminatı ile yıl içerisinde bir defaya mahsus olmak şartıyla bir adet ön veya arka cam hasarlarınızı karşılayabilirsiniz. İlk ücretsiz cam değişimi sonrası yaşanacak cam hasarları poliçe kapsamında karşılanmaktadır. Yalnız kasko hasarsızlığınızı etkilemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kıymet Kazanma Tenzili Muafiyet Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortasının ana amacı oluşacak hasarlar sonucunda oluşan kayıpları hasar öncesi haline getirmektir. Bu bağlamda araç hasarların sonucunda araç eski haline dönecek ekstradan değer kazanmayacak şekilde hesaplama yapılır. ',
          subList: null
        },
        {
          paragraph:
            'Aracınızda yapılacak sonucu oluşan değer artışı hesaplanarak tazminat ödemesinden düşülmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Kasko Sigortası Hasarsızlık İndirimi Ne Kadar Geçerlidir?',
      content: [
        {
          paragraph:
            'Generali Sigorta hasarsızlık indiriminiz 3 aya kadar korumaktadır. 3 ay içerinde tekrar poliçe yaptırmanız durumunda hasarsızlık indiriminizden faydalanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Araç Kaskosu Coğrafi Sınır Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigorta kasko sigortası, Türkiye sınırları içerisinde geçerlidir. Yalnız yurt dışı teminatı ekletmeniz durumunda kasko sigortanızı yurt dışında da güvenle kullanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Hasarlarında İstenilen Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Hasar anında istenen belgeler hasar ve hasar büyüklüğüne göre farklılık gösterebilir.',
          subList: [
            'Alkol raporu,',
            'Araç ve olay yeri resimleri,',
            'Ehliyet fotokopisi,',
            'Kaza Tespit Tutanağı,',
            'Ruhsat fotokopisidir.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Kasko Hasarsızlık İndirimi Basamakları Nelerdir?',
      content: [
        {
          paragraph:
            'Kasko hasarsızlık indirimi poliçe vadesi içerinde her hangi bir hasar alınması sonucunda kazanılan ekstra indirimdir.',
          subList: null
        },
        {
          paragraph: 'Hasarsızlık indirimleri 4 basamaktan oluşmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu basamaklar;',
          subList: [
            'Basamak hasarsızlıkta %30 oranında indirim kazanılır.',
            'Basamak hasarsızlıkta %40 oranında indirim kazanılır.',
            'Basamak hasarsızlıkta %50 oranında indirim kazanılır.',
            'Basamak hasarsızlıkta %60 oranında indirim kazanılır.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Kasko Mini Onarım Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Mini onarım teminatı, aracınızda oluşan küçük boyutlu göçük veya çizikleri hasarsızlığınızı bozmadan yaptırmanıza olanak sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Kasko Mini Onarım Neleri Kapsar?',
      content: [
        {
          paragraph: 'Mini onarım teminatı;',
          subList: [
            'Küçük çizikler,',
            'Küçük çaplı göçükler,',
            'Boya tamiri,',
            'İç döşeme tamiri,',
            'Cam ve plastik hasarlarını kapsamaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Kasko Sigortası Kaç Gün İçinde Hasar Ödemesi Yapar?',
      content: [
        {
          paragraph:
            'Generali Sigorta aracınıza pert onayı verilmesi halinde 15 gün içerinde ödeme yapmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Yedek Anahtar Olmadan Kasko Yapılır Mı?',
      content: [
        {
          paragraph:
            'Sigorta tanzim edilirken yedek anahtarınızınız olmadığını belirtmeniz durumunda kasko poliçesi satın alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Far Hasarı Kasko Sigortasının Bozar Mı?',
      content: [
        {
          paragraph:
            'Poliçe kapsamına 1 âdeti aşmamak kaydıyla far hasarınız tamiratı kasko poliçenizi bozmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'LPG’li Araca Kasko Yapılır Mı?',
      content: [
        {
          paragraph:
            'LPG’li araca kasko sigortası yapılmaktadır. Yalnız kasko sigortası tanzim edilirken LPG aksesuar olarak eklenmesi gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Deprem Sonucu Oluşan Hasarları Kasko Karşılar Mı?',
      content: [
        {
          paragraph:
            'Poliçenizde deprem teminatı bulunması durumunda karşılanmaktadır. Deprem teminatı alınmadığı takdirde deprem hasarları karşılanmaz veya belirli bir muafiyet uygulanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Alkol Kullanımı Sonucu Oluşan Hasarları Kasko Karşılar Mı?',
      content: [
        {
          paragraph:
            'Genel şartlar ve trafik kuralları gereğince alkollü araç kullanımı yasaktır. Bu nedenle oluşacak hasarlar poliçe kapsamında karşılanmaz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Sigortası Ne Zaman Yenilenir?',
      content: [
        {
          paragraph:
            'Kasko sigortası başlangıç tarihinden itibaren 1 yıl sonra sona ermektedir. Bu sebeple kasko poliçenizi üzerinde yazan bitiş tarihinden 30 gün önce yenileme teklifi alabilir ve poliçenizi oluşturabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Kasko Sigortasını Kaç Taksitle Alınabilir?',
      content: [
        {
          paragraph:
            'Kasko sigortanızı kredi kartınızla 9 taksit seçeneği ile alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Aracı Sigortalı Haricinde Kullanılması Sonucu Oluşan Hasarlar Kaskodan Karşılanır Mı?',
      content: [
        {
          paragraph:
            'Kasko sigortalarında fiyat avantajından dolayı sürücü kısıtlamaları uygulana bilmektedir. Eğer poliçenize sürücü kısıtlaması ekletmeniz durumunda hasarınız karşılanmamaktadır. Sürücü kısıtlaması bulunmayan sigortalarda hasar sigorta şirketi tarafından karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Sigortası İhtiyari Mali Mesuliyet Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortası içerisinde sunulan İMM teminatı kusurlu olduğunuz kazalarda karşı tarafa verdiğiniz hasar tutarının trafik sigorta teminatları içerinde sunulan limitlerin üstünde kalması durumunda devreye girmekte olup limit üstünde kalan kısmı karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Muafiyetli Poliçe İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Muafiyet indirimi, hasar sonucunda oluşacak hasara katılımınızı belirmektedir. Oluşan hasarlar sonucunda poliçede belirtilmiş muafiyet oranı kadar hasara katılım sağlamaktasınız. ',
          subList: null
        }
      ]
    },
    {
      title: 'Aracım Çalındı Ne Yapmalıyım?',
      content: [
        {
          paragraph: null,
          subList: [
            'Aracın çalınması halinde kolluk kuvvetlerine haber vererek zabıt tutturmalısınız. ',
            'Tutulan zabıt ve ruhsatınızı sigorta şirketine ileterek hasar dosyası açılmasını sağlamalısınız.',
            'Hasar dosyası açılması durumunda 30 günlük bir bekleme süresi bulunmaktadır. Bu süre zarfı içerisinde aracınızın bulunması beklenmektedir.',
            'Aracınızın bulunmaması durumuna araç değeri hesaplanarak verilen onay sonrasında 15 gün içerinde tarafınıza ödeme yapılmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Tahmini Kasko Fiyatları Neye Göre Hesaplanır?',
      content: [
        {
          paragraph:
            'Kasko sigortası fiyatları sigortalı bilgileri, araç bilgileri, araçta bulunan ek aksesuarlar, sigortalının geçmiş hasar bilgileri, istenen teminatlara ve plaka il koduna göre değişmektedir. En doğru fiyata ulaşmak için ruhsat bilgileriniz ile teklif talebinde bulunmalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Kasko Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph: 'Kasko sigortası teklifi almak için ruhsat bilgileri ve sigortalı bilgileri gereklidir. Bu bilgileri <strong><em><u>alokasko.com</u></em></strong> üzerinde bulunan başvuru formuna girerek veya numaralı hattan uzman danışmanlarımıza ileterek kasko teklifi talep edebilirsiniz.',
          subList: null
        },
        {
          paragraph: 'Talebiniz doğrultusunda en uygun kasko teklifi hazırlanarak size sunulmaktadır. Sunulan teklifi değerlendirebilir, kasko sigortası hakkında detaylı bilgi alabilir ve poliçe satın alarak aracınızı güvence altına alablirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
